// @ts-nocheck
/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Engage UIApi endpoints
 * API to be used only by the engage UI
 * OpenAPI spec version: 1.0
 */
export type AccountLockResourceState = typeof AccountLockResourceState[keyof typeof AccountLockResourceState];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AccountLockResourceState = {
  LOCKED: 'LOCKED',
  WILL_BE_LOCKED: 'WILL_BE_LOCKED',
} as const;

export interface AccountLockResource {
  endDate: string;
  startDate: string;
  state: AccountLockResourceState;
}

export type ActiveLockReadResourceReason = typeof ActiveLockReadResourceReason[keyof typeof ActiveLockReadResourceReason];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ActiveLockReadResourceReason = {
  CUSTOMER_REQUEST: 'CUSTOMER_REQUEST',
  PAYMENT_CHECK: 'PAYMENT_CHECK',
  PAYMENT_LOST: 'PAYMENT_LOST',
  SUPPORT: 'SUPPORT',
  DSGVO: 'DSGVO',
  DUNNING_PROCESS: 'DUNNING_PROCESS',
} as const;

export interface ActiveLockReadResource {
  lockedAt?: string;
  reason?: ActiveLockReadResourceReason;
}

export interface AddressReadResource {
  addressValidation: AddressValidationReadResource;
  city: string;
  countryCode: string;
  houseNumber?: string;
  postalCode: string;
  street: string;
}

export type AddressValidationReadResourceStatus = typeof AddressValidationReadResourceStatus[keyof typeof AddressValidationReadResourceStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AddressValidationReadResourceStatus = {
  VALIDATED: 'VALIDATED',
  NOT_VALIDATED: 'NOT_VALIDATED',
} as const;

export interface AddressValidationReadResource {
  status?: AddressValidationReadResourceStatus;
}

export interface BillingReadResource {
  accountIdExternal?: string;
  accountLock?: AccountLockResource;
  billingAccountId: string;
  billingDebitorId: string;
  failedPaymentCount: number;
  invoiceConfiguration: InvoiceConfigurationReadResource;
  payment: PaymentReadResource;
  paymentReminder?: PaymentReminderResource;
}

export interface BillingSynchronizationReadResource {
  billingPaymentMethodId?: string;
}

export type BookingSalesPartnerReadResourceSalesPartnerAttributes = {[key: string]: string};

export interface BookingSalesPartnerReadResource {
  salesPartnerAttributes: BookingSalesPartnerReadResourceSalesPartnerAttributes;
  salesPartnerCustomerReferenceId?: string;
  salesPartnerReference: SalesPartnerReferenceReadResource;
}

export type BrandingReadResourceAppUiStyle = typeof BrandingReadResourceAppUiStyle[keyof typeof BrandingReadResourceAppUiStyle];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrandingReadResourceAppUiStyle = {
  ENBW: 'ENBW',
  ADAC: 'ADAC',
  ALLIANZ: 'ALLIANZ',
  ENMA: 'ENMA',
  HYUNDAI: 'HYUNDAI',
  LBBW: 'LBBW',
  SENEC: 'SENEC',
  YELLO: 'YELLO',
  ACE: 'ACE',
  ACV: 'ACV',
} as const;

export type BrandingReadResourceChargingCardStyle = typeof BrandingReadResourceChargingCardStyle[keyof typeof BrandingReadResourceChargingCardStyle];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrandingReadResourceChargingCardStyle = {
  ENBW: 'ENBW',
  ADAC: 'ADAC',
  ALLIANZ: 'ALLIANZ',
  HYUNDAI: 'HYUNDAI',
  LBBW: 'LBBW',
  SENEC: 'SENEC',
  YELLO: 'YELLO',
  ACE: 'ACE',
  ACV: 'ACV',
} as const;

export interface BrandingReadResource {
  appUiStyle?: BrandingReadResourceAppUiStyle;
  chargingCardStyle?: BrandingReadResourceChargingCardStyle;
}

export interface BusinessSystemReferenceCreationResource {
  createdAt: string;
}

export interface CentralIdentityManagementResource {
  businessSystemReferenceCreation?: BusinessSystemReferenceCreationResource;
}

export interface ChargingAccountReadResource {
  chargingAccountId: string;
  emaId: string;
}

export type ChargingContractResourceType = typeof ChargingContractResourceType[keyof typeof ChargingContractResourceType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChargingContractResourceType = {
  UNSPECIFIED: 'UNSPECIFIED',
  PRIVATE: 'PRIVATE',
  COMPANY: 'COMPANY',
  PUBLIC: 'PUBLIC',
  FLEET: 'FLEET',
} as const;

export interface ChargingContractResource {
  address: AddressReadResource;
  billing: BillingReadResource;
  bookings: TariffBookingsReadResource[];
  branding: BrandingReadResource;
  chargingAccount: ChargingAccountReadResource;
  communication: CommunicationReadResource;
  contractNumber: string;
  contractSalesPartner?: ContractSalesPartnerReadResource;
  creation: ContractCreationResource;
  gdprDeletion?: GdprDeletionReadResource;
  id: string;
  lastUpdatedAt: string;
  legacyEndUserId: number;
  legacyEndUserVersion: number;
  lock: LockReadResource;
  lockedForModificationDueToDunning: boolean;
  personalData: PersonalDataReadResource;
  support: SupportReadResource;
  termination?: TerminationInfoResource;
  type: ChargingContractResourceType;
}

export interface ChargingMediaDeactivationResource {
  chargingMediaDeactivatedAt?: string;
}

export interface CommunicationReadResource {
  alternativePhoneNumber?: string;
  emailAddress: string;
  invoiceMailAddress?: string;
  phoneNumber?: string;
  welcomeMailSent: boolean;
}

export interface ContractCountResource {
  /** Number of contracts that are not in termination and not terminated */
  activeContracts: number;
  /** Number of fleet memberships that are active */
  activeFleetMemberships: number;
  /** Number of contracts that are in termination but not yet terminated */
  contractsInTermination: number;
  /** Number of fleet memberships that are no longer active */
  previousFleetMemberships: number;
  /** Number of contracts that are terminated */
  terminatedContracts: number;
}

export type ContractCreationResourceCreationTouchpointType = typeof ContractCreationResourceCreationTouchpointType[keyof typeof ContractCreationResourceCreationTouchpointType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractCreationResourceCreationTouchpointType = {
  B2B_ONLINE: 'B2B_ONLINE',
  B2B_SOLUTION: 'B2B_SOLUTION',
  B2B_API: 'B2B_API',
  B2C: 'B2C',
} as const;

export interface ContractCreationResource {
  createdAt: string;
  createdBy: ContractCreatorResource;
  creationTouchpointType: ContractCreationResourceCreationTouchpointType;
}

export type ContractCreatorResourceType = typeof ContractCreatorResourceType[keyof typeof ContractCreatorResourceType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractCreatorResourceType = {
  CUSTOMER: 'CUSTOMER',
  SUPPORT: 'SUPPORT',
  SYSTEM: 'SYSTEM',
} as const;

export interface ContractCreatorResource {
  displayName: string;
  identifier: string;
  type: ContractCreatorResourceType;
}

export type ContractLockerReadResourceType = typeof ContractLockerReadResourceType[keyof typeof ContractLockerReadResourceType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractLockerReadResourceType = {
  SUPPORT: 'SUPPORT',
  PROCESS: 'PROCESS',
} as const;

export interface ContractLockerReadResource {
  displayName: string;
  identifier?: string;
  type: ContractLockerReadResourceType;
}

export interface ContractOwnershipCreationResource {
  createdAt: string;
  creator: ContractOwnershipCreatorResource;
}

export type ContractOwnershipCreatorResourceType = typeof ContractOwnershipCreatorResourceType[keyof typeof ContractOwnershipCreatorResourceType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractOwnershipCreatorResourceType = {
  CUSTOMER: 'CUSTOMER',
  SUPPORT: 'SUPPORT',
  PROCESS: 'PROCESS',
} as const;

export interface ContractOwnershipCreatorResource {
  displayName: string;
  identifier: string;
  type: ContractOwnershipCreatorResourceType;
}

export interface ContractOwnershipDeletionResource {
  deletedAt: string;
}

export interface ContractOwnershipResource {
  contractReference: ContractReferenceResource;
  creation: ContractOwnershipCreationResource;
  deletion?: ContractOwnershipDeletionResource;
  id: string;
  lastUpdatedAt: string;
  legacyProfileId: number;
  name: string;
}

export interface ContractReferenceResource {
  chargingAccountId: string;
  contractId: string;
  emaId: string;
  legacyEndUserId: number;
}

export interface ContractSalesPartnerReadResource {
  salesPartnerCustomerReferenceId?: string;
  salesPartnerDepartment?: string;
  salesPartnerReference: SalesPartnerReferenceReadResource;
}

export interface ContractSearchRequest {
  /** Page number (0-based) */
  pageNumber: number;
  /** Number of results per page */
  pageSize: number;
  /** the search query */
  query: string;
}

export interface ContractSearchResponse {
  contracts?: ChargingContractResource[];
  totalCount?: number;
}

export interface ContractTerminationResource {
  chargingMediaDeactivation: ChargingMediaDeactivationResource;
  communication: TerminationCommunicationResource;
  completedAt?: string;
  contractId: string;
  creation: TerminationCreationResource;
  id: string;
  terminateAt: string;
}

export type CreditCardReadResourceAllOfCreditCardType = typeof CreditCardReadResourceAllOfCreditCardType[keyof typeof CreditCardReadResourceAllOfCreditCardType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreditCardReadResourceAllOfCreditCardType = {
  VISA: 'VISA',
  MASTERCARD: 'MASTERCARD',
  AMERICAN_EXPRESS: 'AMERICAN_EXPRESS',
} as const;

export type CreditCardReadResourceAllOf = {
  commonInfo?: PaymentMethodCommonReadResource;
  creditCardType?: CreditCardReadResourceAllOfCreditCardType;
  creditCardVerification?: CreditCardVerificationResource;
  maskedCreditCardNumber?: string;
  pseudoCreditCardNumber?: string;
  validUntil?: string;
};

export type CreditCardReadResourceType = typeof CreditCardReadResourceType[keyof typeof CreditCardReadResourceType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreditCardReadResourceType = {
  CREDIT_CARD: 'CREDIT_CARD',
} as const;

export type CreditCardReadResource = Omit<PaymentMethodReadResource & CreditCardReadResourceAllOf, 'type'> & {
  type: CreditCardReadResourceType;
} & Required<Pick<Omit<PaymentMethodReadResource & CreditCardReadResourceAllOf, 'type'> & {
  type: CreditCardReadResourceType;
}, 'commonInfo' | 'creditCardType' | 'maskedCreditCardNumber' | 'pseudoCreditCardNumber' | 'validUntil'>>;

export interface CreditCardVerificationResource {
  creditCardVerificationId: string;
}

export interface CustomerCreationResource {
  createdAt: string;
}

export interface CustomerResource {
  creation: CustomerCreationResource;
  id: string;
  lastUpdatedAt: string;
  mobilityPlusId: string;
  ownedChargingContracts: ContractOwnershipResource[];
}

export interface ExtendedInvoiceAttributeReadResource {
  name: string;
  value: string;
}

export interface GdprDeletionReadResource {
  requestedAt: string;
}

export interface GetContractResponse {
  contract: ChargingContractResource;
  contractCounts: ContractCountResource;
  customer?: CustomerResource;
  identity?: MobilityPlusIdentityResource;
  termination?: ContractTerminationResource;
}

export interface HelloResponse {
  message?: string;
}

export interface InfoMailResource {
  deliveredAt?: string;
  emailRequestIds: string[];
  sentAt?: string;
}

export interface InvoiceConfigurationReadResource {
  containsCsv: boolean;
  extendedInvoiceAttributes: ExtendedInvoiceAttributeReadResource[];
  isReduced: boolean;
}

export type InvoiceReadResourceAllOf = {
  commonInfo?: PaymentMethodCommonReadResource;
  paymentDueWithinDay?: number;
};

export type InvoiceReadResourceType = typeof InvoiceReadResourceType[keyof typeof InvoiceReadResourceType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InvoiceReadResourceType = {
  INVOICE: 'INVOICE',
} as const;

export type InvoiceReadResource = Omit<PaymentMethodReadResource & InvoiceReadResourceAllOf, 'type'> & {
  type: InvoiceReadResourceType;
} & Required<Pick<Omit<PaymentMethodReadResource & InvoiceReadResourceAllOf, 'type'> & {
  type: InvoiceReadResourceType;
}, 'commonInfo' | 'paymentDueWithinDay'>>;

export type LockChangeReadResourceReason = typeof LockChangeReadResourceReason[keyof typeof LockChangeReadResourceReason];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LockChangeReadResourceReason = {
  CUSTOMER_REQUEST: 'CUSTOMER_REQUEST',
  PAYMENT_CHECK: 'PAYMENT_CHECK',
  PAYMENT_LOST: 'PAYMENT_LOST',
  SUPPORT: 'SUPPORT',
  DSGVO: 'DSGVO',
  DUNNING_PROCESS: 'DUNNING_PROCESS',
} as const;

export interface LockChangeReadResource {
  changedAt: string;
  description: string;
  locked: boolean;
  locker: ContractLockerReadResource;
  reason: LockChangeReadResourceReason;
}

export interface LockReadResource {
  activeLock?: ActiveLockReadResource;
  changes: LockChangeReadResource[];
}

export interface MobileDeviceResource {
  appVersion: string;
  clientOsVersion: string;
  createdAt: string;
  deviceModel: string;
  id: string;
  installationIdentifier?: string;
  lastUsedAt: string;
  legacyDeviceId: string;
  platform: string;
  pushMessagingToken: string;
  selectedLegacyProfileId?: number;
  versionCode: string;
}

export interface MobilityPlusIdentityResource {
  centralIdentityManagement: CentralIdentityManagementResource;
  ciamLoginSyncedAt?: string;
  createdAt: string;
  id: string;
  lastUpdatedAt: string;
  legacyCiamLoginId?: number;
  mobileDevices: MobileDeviceResource[];
  myEnergyKey: MyEnergyKeyResource;
}

export interface MyEnergyKeyResource {
  emailAddress?: string;
  subject?: string;
  subjectChanges: SubjectChangeResource[];
}

export interface PaymentCreationReadResource {
  createdAt: string;
  creator: PaymentMethodCreatorResource;
}

export interface PaymentDeactivationReadResource {
  deactivatedAt: string;
  deactivator: PaymentMethodDeactivatorResource;
}

export type PaymentMethodCommonReadResourceVerificationType = typeof PaymentMethodCommonReadResourceVerificationType[keyof typeof PaymentMethodCommonReadResourceVerificationType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentMethodCommonReadResourceVerificationType = {
  UNVERIFIED: 'UNVERIFIED',
  VERIFIED: 'VERIFIED',
  FAILED: 'FAILED',
  INVALID: 'INVALID',
} as const;

export interface PaymentMethodCommonReadResource {
  billingSynchronization: BillingSynchronizationReadResource;
  creation: PaymentCreationReadResource;
  deactivation?: PaymentDeactivationReadResource;
  isActive: boolean;
  verificationType: PaymentMethodCommonReadResourceVerificationType;
  verifiedAt?: string;
}

export type PaymentMethodCreatorResourceType = typeof PaymentMethodCreatorResourceType[keyof typeof PaymentMethodCreatorResourceType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentMethodCreatorResourceType = {
  CUSTOMER: 'CUSTOMER',
  SUPPORT: 'SUPPORT',
  PROCESS: 'PROCESS',
} as const;

export interface PaymentMethodCreatorResource {
  displayName: string;
  identifier?: string;
  type: PaymentMethodCreatorResourceType;
}

export type PaymentMethodDeactivatorResourceType = typeof PaymentMethodDeactivatorResourceType[keyof typeof PaymentMethodDeactivatorResourceType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentMethodDeactivatorResourceType = {
  CUSTOMER: 'CUSTOMER',
  SUPPORT: 'SUPPORT',
  PROCESS: 'PROCESS',
} as const;

export interface PaymentMethodDeactivatorResource {
  displayName: string;
  identifier?: string;
  type: PaymentMethodDeactivatorResourceType;
}

/**
 * PaymentMethodReadResource base class
 */
export interface PaymentMethodReadResource {
  type: string;
}

export type PaymentReadResourceAllowedPaymentMethodTypesItem = typeof PaymentReadResourceAllowedPaymentMethodTypesItem[keyof typeof PaymentReadResourceAllowedPaymentMethodTypesItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentReadResourceAllowedPaymentMethodTypesItem = {
  CREDIT_CARD: 'CREDIT_CARD',
  SEPA: 'SEPA',
  INVOICE: 'INVOICE',
} as const;

export type PaymentReadResourcePaymentMethodsItem = CreditCardReadResource | InvoiceReadResource | SEPAReadResource;

export interface PaymentReadResource {
  allowedPaymentMethodTypes: PaymentReadResourceAllowedPaymentMethodTypesItem[];
  paymentMethods: PaymentReadResourcePaymentMethodsItem[];
}

export interface PaymentReminderResource {
  outstandingAmount: number;
}

export type PersonalDataReadResourceSalutation = typeof PersonalDataReadResourceSalutation[keyof typeof PersonalDataReadResourceSalutation];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PersonalDataReadResourceSalutation = {
  MR: 'MR',
  MS: 'MS',
  MX: 'MX',
  UNKNOWN: 'UNKNOWN',
} as const;

export interface PersonalDataReadResource {
  birthday?: string;
  company?: string;
  firstName: string;
  lastName: string;
  salesTaxId?: string;
  salutation: PersonalDataReadResourceSalutation;
}

export type SEPAReadResourceAllOf = {
  accountHolder?: string;
  billingMandateReference?: string;
  commonInfo?: PaymentMethodCommonReadResource;
  iban?: string;
  mandate?: string;
};

export type SEPAReadResourceType = typeof SEPAReadResourceType[keyof typeof SEPAReadResourceType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SEPAReadResourceType = {
  SEPA: 'SEPA',
} as const;

export type SEPAReadResource = Omit<PaymentMethodReadResource & SEPAReadResourceAllOf, 'type'> & {
  type: SEPAReadResourceType;
} & Required<Pick<Omit<PaymentMethodReadResource & SEPAReadResourceAllOf, 'type'> & {
  type: SEPAReadResourceType;
}, 'accountHolder' | 'commonInfo' | 'iban'>>;

export interface SalesPartnerReferenceReadResource {
  salesPartnerId: string;
  salesPartnerName: string;
}

export type SubjectChangeResourceType = typeof SubjectChangeResourceType[keyof typeof SubjectChangeResourceType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubjectChangeResourceType = {
  CREATED: 'CREATED',
  UPDATED: 'UPDATED',
} as const;

export interface SubjectChangeResource {
  changedAt: string;
  newSubject: string;
  type: SubjectChangeResourceType;
}

export interface SupportReadResource {
  note?: string;
}

export type TariffBookingsReadResourceBookedBy = typeof TariffBookingsReadResourceBookedBy[keyof typeof TariffBookingsReadResourceBookedBy];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TariffBookingsReadResourceBookedBy = {
  CUSTOMER_B2C: 'CUSTOMER_B2C',
  CUSTOMER_B2B: 'CUSTOMER_B2B',
  CUSTOMER_B2B_API: 'CUSTOMER_B2B_API',
  ENBW_SUPPORT: 'ENBW_SUPPORT',
  ENBW_MIGRATION: 'ENBW_MIGRATION',
  UNKNOWN: 'UNKNOWN',
} as const;

export interface TariffBookingsReadResource {
  bookedAt: string;
  bookedBy: TariffBookingsReadResourceBookedBy;
  bookingSalesPartner?: BookingSalesPartnerReadResource;
  ignoreMinDurationOfTariff: boolean;
  legacyContractNumber: number;
  tariffId: number;
  tariffName: string;
  validFrom: string;
}

export interface TerminationCommunicationResource {
  infoMail: InfoMailResource;
}

export type TerminationCreationResourceChannel = typeof TerminationCreationResourceChannel[keyof typeof TerminationCreationResourceChannel];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TerminationCreationResourceChannel = {
  APP: 'APP',
  PHONE: 'PHONE',
  EMAIL: 'EMAIL',
  LETTER: 'LETTER',
  ADMIN_UI: 'ADMIN_UI',
  SYSTEM: 'SYSTEM',
  OTHER: 'OTHER',
  B2B_API: 'B2B_API',
} as const;

export type TerminationCreationResourceReason = typeof TerminationCreationResourceReason[keyof typeof TerminationCreationResourceReason];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TerminationCreationResourceReason = {
  INITIAL_MIGRATION: 'INITIAL_MIGRATION',
  BAD_PAYMENT: 'BAD_PAYMENT',
  PRICING: 'PRICING',
  QUALITY_OF_SERVICE: 'QUALITY_OF_SERVICE',
  NOT_NEEDED_ANYMORE: 'NOT_NEEDED_ANYMORE',
  REVOCATION_OF_CONSENT: 'REVOCATION_OF_CONSENT',
  OBJECTION_TO_TARIFF_CHANGE: 'OBJECTION_TO_TARIFF_CHANGE',
  EXTRAORDINARY: 'EXTRAORDINARY',
  EXTRAORDINARY_SUBSTITUTE: 'EXTRAORDINARY_SUBSTITUTE',
  OTHER: 'OTHER',
  ORDINARY: 'ORDINARY',
  CONTRACT_REVOCATION: 'CONTRACT_REVOCATION',
  CONTRACT_REVOCATION_SUBSTITUTE: 'CONTRACT_REVOCATION_SUBSTITUTE',
} as const;

export interface TerminationCreationResource {
  channel: TerminationCreationResourceChannel;
  createdAt: string;
  createdBy: TerminationCreatorReadResource;
  reason: TerminationCreationResourceReason;
  requestedAt: string;
  trigger: TerminationTriggerResource;
}

export type TerminationCreatorReadResourceType = typeof TerminationCreatorReadResourceType[keyof typeof TerminationCreatorReadResourceType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TerminationCreatorReadResourceType = {
  CUSTOMER: 'CUSTOMER',
  ENBW: 'ENBW',
} as const;

export interface TerminationCreatorReadResource {
  displayName: string;
  identifier?: string;
  type: TerminationCreatorReadResourceType;
}

export interface TerminationInfoResource {
  contractTerminationId: string;
  requestedAt: string;
  terminateAt: string;
}

export type TerminationTriggerResourceTriggerType = typeof TerminationTriggerResourceTriggerType[keyof typeof TerminationTriggerResourceTriggerType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TerminationTriggerResourceTriggerType = {
  CUSTOMER: 'CUSTOMER',
  ENBW: 'ENBW',
} as const;

export interface TerminationTriggerResource {
  displayName: string;
  identifier?: string;
  triggerType: TerminationTriggerResourceTriggerType;
}

